import React, { FC } from "react";
import { useSelector } from "react-redux";

import { ActionableMessage, ActionableMessageProps } from "../../common";
import { selectCurrentUser } from "../../../store/reducers/user";
import { UIStatus } from "../../../types/GlobalTypes";

export const LiftLimitMessage: FC<
  Omit<
    ActionableMessageProps,
    "heading" | "text" | "type" | "icon" | "ctaContent"
  >
> = (props) => {
  const {
    kyc_second_level_count_threshold,
    kyc_second_level_amount_threshold,
  } = useSelector(selectCurrentUser);

  return (
    <ActionableMessage
      heading="You can Receive"
      text={
        <ul className="list-disc list-inside">
          <li>Max {kyc_second_level_count_threshold} payments/month</li>

          <li>
            Up to {kyc_second_level_amount_threshold / 1000}k EUR total/month
          </li>
        </ul>
      }
      type={UIStatus.WARNING}
      icon="KYC"
      ctaContent="Lift limits"
      {...props}
    />
  );
};
